export default __webpack_public_path__ + "static/Visual_Vocab_Portrait_H264-b404f03687551144d7ea4f994529b392.mp4";